import styled from '@emotion/styled';

// PopulationCharts 스타일
export const ChartsContainer = styled.div`
    width: 100%;
    height: 100%;
    margin: 0 auto;
    padding: 0;
`;

// Table Components 스타일
export const TableWrapper = styled.div`
    width: 100%;
    margin-bottom: 24px;
`;

export const TableTitle = styled.div`
    padding-top: 8px;
    margin-bottom: 40px;
    text-align: center;
    font-weight: 600;
    font-size: 16px;
    color: #2c3e50;
`;

export const StyledTableContainer = styled.div`
    overflow: auto;
    padding: 0 16px;
`;

export const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-family: 'SCDream4';
    font-size: 0.875rem;
`;

export const StyledTableHead = styled.thead`
    position: sticky;
    top: 0;
    z-index: 1;
`;

export const StyledTableBody = styled.tbody``;

export const StyledTableRow = styled.tr`
    &:hover {
        background-color: rgba(0, 0, 0, 0.04);
    }
`;

export const StyledTableHeaderCell = styled.th`
    background-color: #f5f5f5;
    font-weight: 600;
    padding: 12px 8px;
    text-align: ${(props) => props.align || 'left'};
    border-bottom: 1px solid #e0e0e0;
    color: #333;
    font-size: 13px;
`;

export const StyledTableCell = styled.td`
    padding: 12px 8px;
    text-align: ${(props) => props.align || 'left'};
    border-bottom: 1px solid #e0e0e0;
    color: ${(props) => props.color || '#333'};
    font-weight: ${(props) => props.fontWeight || 'normal'};
`;

export const StyledTableHeader = styled.th`
    background-color: #f5f5f5;
    font-weight: 600;
    padding: 12px 8px;
    text-align: ${(props) => props.align || 'left'};
    border-bottom: 1px solid #e0e0e0;
    color: #333;
    font-size: 12px;
`;

// PopulationChartModal 스타일
export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    // background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    pointer-events: none;
`;

export const ModalContent = styled.div`
    background: white;
    border-radius: 12px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
    min-width: 35vw;
    // overflow-y: auto;
    position: absolute;
    pointer-events: auto;

    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
`;

export const CloseButton = styled.button`
    // position: absolute;
    // top: 15px;
    // right: 15px;
    background: none;
    border: none;
    font-size: 30px;
    cursor: pointer;
    color: #888;
    transition: color 0.2s ease-in-out;
    line-height: 1;
    padding: 5px;
    z-index: 10;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;

    &:hover {
        color: #333;
        background-color: rgba(0, 0, 0, 0.05);
    }
`;

export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    align-items: center;
    cursor: grab;
    user-select: none;
    touch-action: none;
    transition: cursor 0.2s ease;
    border-bottom: 1px solid #ddd;

    &:active {
        cursor: grabbing;
    }

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
`;

export const ModalTitle = styled.h2`
    font-size: 18px;
    font-weight: bold;
    color: #333;
`;

export const TabContainer = styled.div`
    margin-bottom: 20px;
`;

export const TabList = styled.div`
    display: flex;
    border-bottom: 1px solid #ddd;
    margin-bottom: 20px;
`;

export const Tab = styled.button`
    padding: 15px 20px;
    border: none;
    background: none;
    cursor: pointer;
    font-size: 15px;
    font-family: 'SCDream4';
    color: ${(props) => (props.active ? '#007bff' : '#666')};
    border-bottom: 3px solid transparent;
    transition: all 0.3s ease;

    &:hover {
        color: #007bff;
    }

    &.active {
        color: #007bff;
        font-weight: bold;
        border-bottom: 3px solid #007bff;
        background-color: #e9f5ff;
    }
`;

export const TabContent = styled.div`
    display: ${(props) => (props.active ? 'block' : 'none')};
`;
